import { InspectionSheetPage } from "./InspectionSheetPage";

const InspectionSheet = () => {
	return <InspectionSheetPage />;
};

export default InspectionSheet;
